import styled from '@emotion/styled';

export const Container = styled.div`
    // padding: 24px 16px;
    // margin: 0 auto;
    // @media (min-width: 343px) {

    // };

    // @media (min-width: 688px) {
    //     padding: 40px 8px;
    // }

    // @media (min-width: 1280px) {
    //     padding: 0 80px;
    // };
`;